import React, { useEffect, useState } from "react";
import { BaSeBackendNoSignalPage, BaSeIcon } from "@base/react";
import { Acessos } from "./components/Acessos";

import styles from "./styles.module.css";

import { FlexDirectionRow, MainContainer, Title, } from "../../components/StyledComponents";
import { useHistory } from "react-router-dom";
import { SelectPage } from "./components/SelectPage";
import { Agendamentos } from "./components/Agendamentos";
import { Notificacoes } from "./components/Notificacoes";
import { LeadsEventos } from "./components/LeadsEventos";
import { Diagnosticos } from "./components/Diagnosticos";
import { RegistroSas } from "./components/RegistroSas";
import { Usuarios } from "./components/Usuarios";
import { AtendimentosSse } from "./components/AtendimentosSse";
import { PerfilUsuarios } from "./components/PerfilUsuarios";
import LogoRelatorio from "../../images/logoRelatorio.png";
import { useRouteMatch } from "react-router";
import { useApp } from "../../context/app";
import useAbortControllerStore from "../../stores/useAbortControllerStore";
import { SalaEmpreendedor } from "./components/SalaEmpreendedor";


const SCREENS = [
    {
        id: "selecione",
        component: SelectPage,
        label: "Escolha o relatório...",
    },
    {
        id: "acessos",
        component: Acessos,
        label: "Acessos",
    },
    {
        id: "agendamentos",
        component: Agendamentos,
        label: "Agendamentos",
    },
    {
        id: "atendimentos-sse",
        component: AtendimentosSse,
        label: "Atendimentos SSE",
    },
    {
        id: "diagnosticos",
        component: Diagnosticos,
        label: "Diagnósticos realizados",
    },
    {
        id: "leads-eventos",
        component: LeadsEventos,
        label: "Leads de eventos",
    },
    {
        id: "notificacoes",
        component: Notificacoes,
        label: "Notificações",
    },
    {
        id: "registro-sas",
        component: RegistroSas,
        label: "SAS - Registro de atendimentos APP Sebrae",
    },
    {
        id: "usuarios",
        component: Usuarios,
        label: "Usuários",
    },
    {
        id: "perfil-usuarios",
        component: PerfilUsuarios,
        label: "Perfil de usuário",
    },
    {
        id: "atendimento-salas",
        component: SalaEmpreendedor,
        label: "Atendimentos SALA",
    },
];

const defaultScreen = SCREENS[0]?.id

const NewReports = () => {

    const history = useHistory();
    const [error] = useState(false);
    const matchReportId = useRouteMatch("/reports/:reportId");
    const matchTabId = useRouteMatch("/reports/:reportId/tab/:tabId");
    const verMapaMatch = useRouteMatch("/reports/AtendimentosSse/VerMapa");
    const reportId = matchReportId?.params?.reportId;
    const tabId = matchTabId?.params?.tabId;
    const [optionSelected, setOptionSelected] = useState(defaultScreen);
    const {setRenderIncludeScreen, setManageItem, renderIncludeScreen} =
        useApp();


    const ScreenComponent = SCREENS.find((s) => s.id === optionSelected)?.component;
    const cancelRequest = useAbortControllerStore((state) => state.cancelRequest);

    useEffect(() => {
        if (verMapaMatch?.isExact) {
            setRenderIncludeScreen(true);
        }
        // eslint-disable-next-line
    }, [verMapaMatch]);

    useEffect(() => {
        setOptionSelected(reportId ?? defaultScreen);

        return () => {
            cancelRequest();
        };
    }, [reportId, cancelRequest]);

    const handleChangeSelect = (event) => {
        const value = event?.target?.value;
        const url = value === defaultScreen ? "/reports/" : `/reports/${value}`;
        history.push(url);
        setOptionSelected(value);
    };

    if (error) {
        return <BaSeBackendNoSignalPage/>;
    }

    const handleClickBack = () => {
        const url = reportId ? `/reports/${reportId}` : "/reports/";
        history.push(url);
        setRenderIncludeScreen(false);
        setManageItem({});
    };

    return (
        <>
            <MainContainer backgroundColor={"#00ccff"}>
                <FlexDirectionRow>
                    <FlexDirectionRow style={{width: "100%"}}>
                        {/* <MdContentCopy size={40} color="#ffffff" /> */}
                        <img
                            alt="imagem"
                            style={{width: "2.5rem", height: "2.5rem"}}
                            src={LogoRelatorio}
                        />
                        <Title>Relatórios</Title>
                    </FlexDirectionRow>

                    <FlexDirectionRow
                        position="end"
                        style={{alignItems: "center", width: "100%"}}
                    >
                        {!renderIncludeScreen ? (
                            <div className={styles.selection_box}>
                                <select
                                    className={styles.selection_box_content}
                                    onChange={handleChangeSelect}
                                    value={optionSelected}
                                >
                                    {SCREENS.map((s) => (
                                        <option key={s.id} value={s.id}>
                                            {s.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        ) : (
                            <BaSeIcon
                                onClick={() => handleClickBack()}
                                name={"arrow-circle-left"}
                                description="Voltar"
                                color="#ffffff"
                                size={50}
                            />
                        )}
                    </FlexDirectionRow>
                </FlexDirectionRow>
            </MainContainer>
            {!!optionSelected && ScreenComponent && (
                <ScreenComponent tabId={tabId}/>
            )}
        </>
    );
};

export default NewReports;
